import React from 'react';
export interface IconProps {
  color?: string;
  width?: number;
  height?: number;
}

const TeamIcon = ({ color = '#00B4D8', width = 24, height = 24 }: IconProps) => (
  <svg
    viewBox={`0 0 ${width} ${height}`}
    width={width}
    height={height}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
  >
    <rect width={width} height={height} rx="23" fill="#CAF0F8" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25 16C25 16.5523 24.5523 17 24 17C23.4477 17 23 16.5523 23 16C23 15.4477 23.4477 15 24 15C24.5523 15 25 15.4477 25 16ZM27 16C27 17.6569 25.6569 19 24 19C22.3431 19 21 17.6569 21 16C21 14.3431 22.3431 13 24 13C25.6569 13 27 14.3431 27 16ZM17 20C18.1046 20 19 19.1046 19 18C19 16.8954 18.1046 16 17 16C15.8954 16 15 16.8954 15 18C15 19.1046 15.8954 20 17 20ZM33 18C33 19.1046 32.1046 20 31 20C29.8954 20 29 19.1046 29 18C29 16.8954 29.8954 16 31 16C32.1046 16 33 16.8954 33 18ZM21 20C20.0186 20 19.1472 20.4713 18.5999 21.1999C18.4328 21.0744 18.2251 21 18 21H16C14.3431 21 13 22.3431 13 24V26C13 28.2091 14.7909 30 17 30H18C18.2551 30 18.4879 29.9045 18.6645 29.7473C19.6612 31.6791 21.6764 33 24 33C26.3236 33 28.3388 31.6791 29.3355 29.7473C29.5121 29.9045 29.7449 30 30 30H31C33.2091 30 35 28.2091 35 26V24C35 22.3431 33.6569 21 32 21H30C29.7749 21 29.5672 21.0744 29.4001 21.1999C28.8528 20.4713 27.9814 20 27 20H21ZM30 23V27C30 27.3419 29.9714 27.6771 29.9165 28.0034C29.944 28.0012 29.9719 28 30 28H31C32.1046 28 33 27.1046 33 26V24C33 23.4477 32.5523 23 32 23H30ZM15 24C15 23.4477 15.4477 23 16 23H18V27C18 27.3419 18.0286 27.6771 18.0835 28.0034C18.056 28.0012 18.0281 28 18 28H17C15.8954 28 15 27.1046 15 26V24ZM20 23C20 22.4477 20.4477 22 21 22H27C27.5523 22 28 22.4477 28 23V27C28 29.2091 26.2091 31 24 31C21.7909 31 20 29.2091 20 27V23Z"
      // fill="#023E8A"
      fill={color}
    />
  </svg>
);
export default TeamIcon;
